import * as types from '../mutation-types'
import api from '@/api/quiz'

// initial state
const state = {
    quizzes: [],
    loaded: false,
}

const getters = {
    quizzes: state => state.quizzes,
    quizzesLoaded: state => state.loaded,
}

const actions = {
    getQuizzes({ commit }) {
        commit(types.SET_QUIZZES_LOADED, false );
        api.getQuizzes({_embed: 1},(response) => {
            commit(types.SET_QUIZZES, response._embedded.Quiz );
            commit(types.SET_QUIZZES_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_QUIZZES] (state, quizzes ) {
        state.quizzes = quizzes
    },
    [types.SET_QUIZZES_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


